const countries: { [key: string]: string[] } = {
  de: [
    'Afghanistan',
    'Albanien',
    'Algerien',
    'Andorra',
    'Angola',
    'Antigua und Barbuda',
    'Argentinien',
    'Armenien',
    'Österreich',
    'Aserbaidschan',
    'Bahrain',
    'Bangladesch',
    'Barbados',
    'Weißrussland',
    'Belgien',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivien',
    'Bosnien und Herzegowina',
    'Botswana',
    'Brasilien',
    'Brunei',
    'Bulgarien',
    'Burkina Faso',
    'Burundi',
    'Kap Verde',
    'Kambodscha',
    'Kamerun',
    'Kanada',
    'Zentralafrikanische Republik',
    'Tschad',
    'Kanalinseln',
    'Chile',
    'China',
    'Kolumbien',
    'Komoren',
    'Kongo',
    'Costa Rica',
    'Elfenbeinküste',
    'Kroatien',
    'Kuba',
    'Zypern',
    'Tschechische Republik',
    'Dänemark',
    'Dschibuti',
    'Dominica',
    'Dominikanische Republik',
    'Demokratische Republik Kongo',
    'Ecuador',
    'Ägypten',
    'El Salvador',
    'Äquatorialguinea',
    'Eritrea',
    'Estland',
    'Eswatini',
    'Äthiopien',
    'Färöer-Inseln',
    'Finnland',
    'Frankreich',
    'Französisch-Guayana',
    'Gabun',
    'Gambia',
    'Georgien',
    'Deutschland',
    'Ghana',
    'Gibraltar',
    'Griechenland',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heiliger Stuhl',
    'Honduras',
    'Hongkong',
    'Ungarn',
    'Island',
    'Indien',
    'Indonesien',
    'Iran',
    'Irak',
    'Irland',
    'Isle of Man',
    'Israel',
    'Italien',
    'Jamaika',
    'Japan',
    'Jordanien',
    'Kasachstan',
    'Kenia',
    'Kuwait',
    'Kirgisistan',
    'Laos',
    'Lettland',
    'Libanon',
    'Lesotho',
    'Liberia',
    'Libyen',
    'Liechtenstein',
    'Litauen',
    'Luxemburg',
    'Macao',
    'Madagaskar',
    'Malawi',
    'Malaysia',
    'Malediven',
    'Mali',
    'Malta',
    'Mauretanien',
    'Mauritius',
    'Mayotte',
    'Mexiko',
    'Moldawien',
    'Monaco',
    'Mongolei',
    'Montenegro',
    'Marokko',
    'Mosambik',
    'Myanmar',
    'Namibia',
    'Nepal',
    'Niederlande',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Nordkorea',
    'Nordmazedonien',
    'Norwegen',
    'Oman',
    'Pakistan',
    'Panama',
    'Paraguay',
    'Peru',
    'Philippinen',
    'Polen',
    'Portugal',
    'Katar',
    'Réunion',
    'Rumänien',
    'Russland',
    'Ruanda',
    'St. Helena',
    'St. Kitts und Nevis',
    'St. Lucia',
    'St. Vincent und die Grenadinen',
    'San Marino',
    'São Tomé und Príncipe',
    'Saudi-Arabien',
    'Senegal',
    'Serbien',
    'Seychellen',
    'Sierra Leone',
    'Singapur',
    'Slowakei',
    'Slowenien',
    'Somalia',
    'Südafrika',
    'Südkorea',
    'Südsudan',
    'Spanien',
    'Sri Lanka',
    'Staat Palästina',
    'Sudan',
    'Suriname',
    'Schweden',
    'Schweiz',
    'Syrien',
    'Taiwan',
    'Tadschikistan',
    'Tansania',
    'Thailand',
    'Die Bahamas',
    'Timor-Leste',
    'Togo',
    'Trinidad und Tobago',
    'Tunesien',
    'Türkei',
    'Turkmenistan',
    'Uganda',
    'Ukraine',
    'Vereinigte Arabische Emirate',
    'Vereinigtes Königreich',
    'Vereinigte Staaten',
    'Uruguay',
    'Usbekistan',
    'Venezuela',
    'Vietnam',
    'Westsahara',
    'Jemen',
    'Sambia',
    'Simbabwe',
  ],
  fr: [
    'Afghanistan',
    'Albanie',
    'Algérie',
    'Andorre',
    'Angola',
    'Antigua-et-Barbuda',
    'Argentine',
    'Arménie',
    'Autriche',
    'Azerbaïdjan',
    'Bahreïn',
    'Bangladesh',
    'Barbade',
    'Biélorussie',
    'Belgique',
    'Belize',
    'Bénin',
    'Bhoutan',
    'Bolivie',
    'Bosnie-Herzégovine',
    'Botswana',
    'Brésil',
    'Brunei',
    'Bulgarie',
    'Burkina Faso',
    'Burundi',
    'Cap-Vert',
    'Cambodge',
    'Cameroun',
    'Canada',
    'République centrafricaine',
    'Tchad',
    'Îles Anglo-Normandes',
    'Chili',
    'Chine',
    'Colombie',
    'Comores',
    'Congo',
    'Costa Rica',
    "Côte d'Ivoire",
    'Croatie',
    'Cuba',
    'Chypre',
    'République tchèque',
    'Danemark',
    'Djibouti',
    'Dominique',
    'République dominicaine',
    'République démocratique du Congo',
    'Équateur',
    'Égypte',
    'Salvador',
    'Guinée équatoriale',
    'Érythrée',
    'Estonie',
    'Eswatini',
    'Éthiopie',
    'Îles Féroé',
    'Finlande',
    'France',
    'Guyane française',
    'Gabon',
    'Gambie',
    'Géorgie',
    'Allemagne',
    'Ghana',
    'Gibraltar',
    'Grèce',
    'Grenade',
    'Guatemala',
    'Guinée',
    'Guinée-Bissau',
    'Guyana',
    'Haïti',
    'Saint-Siège',
    'Honduras',
    'Hong Kong',
    'Hongrie',
    'Islande',
    'Inde',
    'Indonésie',
    'Iran',
    'Irak',
    'Irlande',
    'Île de Man',
    'Israël',
    'Italie',
    'Jamaïque',
    'Japon',
    'Jordanie',
    'Kazakhstan',
    'Kenya',
    'Koweït',
    'Kirghizistan',
    'Laos',
    'Lettonie',
    'Liban',
    'Lesotho',
    'Libéria',
    'Libye',
    'Liechtenstein',
    'Lituanie',
    'Luxembourg',
    'Macao',
    'Madagascar',
    'Malawi',
    'Malaisie',
    'Maldives',
    'Mali',
    'Malte',
    'Mauritanie',
    'Maurice',
    'Mayotte',
    'Mexique',
    'Moldavie',
    'Monaco',
    'Mongolie',
    'Monténégro',
    'Maroc',
    'Mozambique',
    'Myanmar',
    'Namibie',
    'Népal',
    'Pays-Bas',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Corée du Nord',
    'Macédoine du Nord',
    'Norvège',
    'Oman',
    'Pakistan',
    'Panama',
    'Paraguay',
    'Pérou',
    'Philippines',
    'Pologne',
    'Portugal',
    'Qatar',
    'Réunion',
    'Roumanie',
    'Russie',
    'Rwanda',
    'Sainte-Hélène',
    'Saint-Christophe-et-Niévès',
    'Sainte-Lucie',
    'Saint-Vincent-et-les-Grenadines',
    'Saint-Marin',
    'Sao Tomé-et-Principe',
    'Arabie saoudite',
    'Sénégal',
    'Serbie',
    'Seychelles',
    'Sierra Leone',
    'Singapour',
    'Slovaquie',
    'Slovénie',
    'Somalie',
    'Afrique du Sud',
    'Corée du Sud',
    'Soudan du Sud',
    'Espagne',
    'Sri Lanka',
    'État de Palestine',
    'Soudan',
    'Suriname',
    'Suède',
    'Suisse',
    'Syrie',
    'Taïwan',
    'Tadjikistan',
    'Tanzanie',
    'Thaïlande',
    'Bahamas',
    'Timor-Leste',
    'Togo',
    'Trinité-et-Tobago',
    'Tunisie',
    'Turquie',
    'Turkménistan',
    'Ouganda',
    'Ukraine',
    'Émirats arabes unis',
    'Royaume-Uni',
    'États-Unis',
    'Uruguay',
    'Ouzbékistan',
    'Venezuela',
    'Viêt Nam',
    'Sahara occidental',
    'Yémen',
    'Zambie',
    'Zimbabwe',
  ],
  it: [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua e Barbuda',
    'Argentina',
    'Armenia',
    'Austria',
    'Azerbaigian',
    'Bahrein',
    'Bangladesh',
    'Barbados',
    'Bielorussia',
    'Belgio',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia ed Erzegovina',
    'Botswana',
    'Brasile',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Capo Verde',
    'Cambogia',
    'Camerun',
    'Canada',
    'Repubblica Centrafricana',
    'Ciad',
    'Isole del Canale',
    'Cile',
    'Cina',
    'Colombia',
    'Comore',
    'Congo',
    'Costa Rica',
    'Costa d’Avorio',
    'Croazia',
    'Cuba',
    'Cipro',
    'Repubblica Ceca',
    'Danimarca',
    'Gibuti',
    'Dominica',
    'Repubblica Dominicana',
    'Repubblica Democratica del Congo',
    'Ecuador',
    'Egitto',
    'El Salvador',
    'Guinea Equatoriale',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Etiopia',
    'Isole Faroe',
    'Finlandia',
    'Francia',
    'Guiana Francese',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germania',
    'Ghana',
    'Gibilterra',
    'Grecia',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Santa Sede',
    'Honduras',
    'Hong Kong',
    'Ungheria',
    'Islanda',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Irlanda',
    'Isola di Man',
    'Israele',
    'Italia',
    'Giamaica',
    'Giappone',
    'Giordania',
    'Kazakistan',
    'Kenya',
    'Kuwait',
    'Kirghizistan',
    'Laos',
    'Lettonia',
    'Libano',
    'Lesotho',
    'Liberia',
    'Libia',
    'Liechtenstein',
    'Lituania',
    'Lussemburgo',
    'Macao',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldive',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Messico',
    'Moldavia',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Marocco',
    'Mozambico',
    'Myanmar',
    'Namibia',
    'Nepal',
    'Paesi Bassi',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Corea del Nord',
    'Macedonia del Nord',
    'Norvegia',
    'Oman',
    'Pakistan',
    'Panama',
    'Paraguay',
    'Perù',
    'Filippine',
    'Polonia',
    'Portogallo',
    'Qatar',
    'Riunione',
    'Romania',
    'Russia',
    'Ruanda',
    'Sant’Elena',
    'Saint Kitts e Nevis',
    'Saint Lucia',
    'Saint Vincent e Grenadine',
    'San Marino',
    'São Tomé e Príncipe',
    'Arabia Saudita',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovacchia',
    'Slovenia',
    'Somalia',
    'Sudafrica',
    'Corea del Sud',
    'Sud Sudan',
    'Spagna',
    'Sri Lanka',
    'Stato di Palestina',
    'Sudan',
    'Suriname',
    'Svezia',
    'Svizzera',
    'Siria',
    'Taiwan',
    'Tagikistan',
    'Tanzania',
    'Thailandia',
    'Bahamas',
    'Timor Est',
    'Togo',
    'Trinidad e Tobago',
    'Tunisia',
    'Turchia',
    'Turkmenistan',
    'Uganda',
    'Ucraina',
    'Emirati Arabi Uniti',
    'Regno Unito',
    'Stati Uniti',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Sahara Occidentale',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ],
  en: [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Austria',
    'Azerbaijan',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Channel Islands',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo',
    'Costa Rica',
    "Cote d'Ivoire",
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'DR Congo',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Faroe Islands',
    'Finland',
    'France',
    'French Guiana',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Holy See',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Korea',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Panama',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Helena',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Somalia',
    'South Africa',
    'South Korea',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'State of Palestine',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'The Bahamas',
    'Timor-Leste',
    'Togo',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ],
};

const providerTypesObj: { [key: string]: { [key: string]: string } } = {
  de: {
    cpo: 'Ladestationsbetreiber / Charge Point Operator (CPO)',
    emp: 'Ladeserviceanbieter / Electric Mobility Providers (EMP)',
    cpoemp: 'Ladestationsbetreiber (CPO) und Ladeserviceanbieter (EMP)',
  },
  fr: {
    cpo: 'Exploitant de borne de recharge / Charge Point Operator (CPO)',
    emp: 'Fournisseur de services de recharge / Electric Mobility Provider (EMP)',
    cpoemp:
      'Exploitant de borne de recharge (CPO) et fournisseur de services de recharge (EMP)',
  },
  it: {
    cpo: 'Gestore della stazione di ricarica / Charge Point Operator (CPO)',
    emp: 'Fornitore di servizi di ricarica / Electric Mobility Provider (EMP)',
    cpoemp:
      'Gestore della stazione di ricarica (CPO) e fornitore di servizi di ricarica (EMP)',
  },
  en: {
    cpo: 'Charge Point Operator (CPO)',
    emp: 'Electric Mobility Providers (EMP)',
    cpoemp: 'Charge Point Operator (CPO) and Electric Mobility Providers (EMP)',
  },
};

export const countriesArr = (locale: string) => countries[locale];
export const providerTypes = (locale: string) => providerTypesObj[locale];
